import { change } from 'redux-form';

import { loading, error, success } from 'State/actions';
import { BidPriceEnum } from 'Common/FieldEnum';
import { ITEM_MAINTENANCE_BID_PRICE_FORM_NAME } from 'Common/FormEnum';

import {
  updateGridField,
  INITIAL_VALUES,
  makeBidItem,
  getGTINNumber,
} from '../../helpers';
import { updateSelectedRowIndex } from '../itemMaintenance/actions';
import * as types from './types';

export const clearControlInfo = () => {
  return {
    type: types.CLEAR_BID_PRICE_CONTROL_INFO,
  };
};

export const resetWarehouseWarning = () => {
  return {
    type: types.RESET_WAREHOUSE_WARNING,
  };
};

export const getWarehouseWarning = (ItemId, BidId, QtyPerUnit) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.BID_PRICE_WAREHOUSE_WARNING_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `INVBidPrice/CanGetWarehouseWarning/${ItemId}/${BidId}/${QtyPerUnit}`
      );
      dispatch(
        success(types.BID_PRICE_WAREHOUSE_WARNING_DATA, response.data.Data)
      );
    } catch (ex) {
      dispatch(error(types.BID_PRICE_WAREHOUSE_WARNING_LOADING_ERROR, ex));
    } finally {
      dispatch(loading(types.BID_PRICE_WAREHOUSE_WARNING_LOADING, false));
    }
  };
};

export const updateGridFormFields = (original, index) => {
  return dispatch => {
    updateGridField(dispatch, original);
    dispatch(updateSelectedRowIndex(index));
  };
};

export const addNewBidItem = newBidItem => {
  return dispatch => {
    dispatch({
      type: types.BID_PRICE_ADD_NEW_ITEM,
      payload: newBidItem,
    });
    dispatch(clearControlInfo());
  };
};

export const updateBidPriceDetails = (input, updateToPrevValue) => {
  return (dispatch, getState) => {
    dispatch({
      type: types.BID_PRICE_UPDATE_GRID,
      payload: {
        input,
        updateToPrevValue,
      },
    });
    if (input.fieldName === BidPriceEnum.VendorId) {
      const bidPriceDetailsData = getState().ItemMaintenanceState
        .updateBidPriceDetails.bidPriceDetailsData;
      bidPriceDetailsData.BidPriceDetails &&
        dispatch(
          change(
            ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
            BidPriceEnum.GTINNumber,
            getGTINNumber(bidPriceDetailsData.BidPriceDetails, input)
          )
        );
    }
    if (updateToPrevValue) {
      dispatch(
        change(
          ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
          input.fieldName,
          input.prevValue
        )
      );
    }
    dispatch(updateSelectedRowIndex(input.selectedIndex));
  };
};

export const getBidPriceDetails = ItemId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.BID_PRICE_DETAILS_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `INVBidPrice/GetBidPriceDetails/${ItemId}`
      );
      if (response.data.Data) {
        dispatch(success(types.BID_PRICE_DETAILS_DATA, response.data.Data));
        const data = getState().ItemMaintenanceState.updateBidPriceDetails
          .bidPriceDetailsData;
        if (data.BidPriceDetails && data.BidPriceDetails.length) {
          updateGridField(dispatch, data.BidPriceDetails[0]);
          dispatch(
            getControlInfo(
              response.data.Data.BidPriceDetails[0].ItemId,
              response.data.Data.BidPriceDetails[0].BidId,
              0
            )
          );
        } else if (
          !+ItemId &&
          data.BidPriceDetails &&
          !data.BidPriceDetails.length
        ) {
          //for new item, manually push 1 bid item
          const bidItem = makeBidItem({
            ...response.data.Data.NewBidPriceDetail,
          });
          bidItem.modified = true;
          dispatch({
            type: types.ADD_BID_FOR_NEW_ITEM,
            payload: bidItem,
          });
          updateGridField(dispatch, bidItem);
          dispatch(updateSelectedRowIndex(0));
        }
      }
    } catch (ex) {
      dispatch(error(types.BID_PRICE_DETAILS_LOADING_ERROR, ex));
    } finally {
      dispatch(loading(types.BID_PRICE_DETAILS_LOADING, false));
    }
  };
};

export const getControlInfo = (ItemId, BidId, index) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.BID_PRICE_CONTROL_INFO_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `INVBidPrice/GetControlInfo/${ItemId}/${BidId}`
      );
      const data = response.data.Data;
      data.ItemId = ItemId;
      data.BidId = BidId;
      dispatch(success(types.BID_PRICE_CONTROL_INFO_DATA, response.data.Data));
      dispatch(updateSelectedRowIndex(index));
    } catch (ex) {
      dispatch(error(types.BID_PRICE_CONTROL_INFO_LOADING_ERROR, ex));
    } finally {
      dispatch(loading(types.BID_PRICE_CONTROL_INFO_LOADING, false));
    }
  };
};

export const removeBidItem = (bidItem, index) => {
  return async (dispatch, getState) => {
    dispatch({
      type: types.BID_PRICE_REMOVE_ITEM,
      payload: {
        bidItem,
        index,
      },
    }).then(() => {
      dispatch(updateSelectedRowIndex(0));
      let data;

      const {
        bidPriceDetailsData,
      } = getState().ItemMaintenanceState.updateBidPriceDetails;
      if (
        bidPriceDetailsData.BidPriceDetails &&
        bidPriceDetailsData.BidPriceDetails.length
      ) {
        data = bidPriceDetailsData.BidPriceDetails[0];
      } else {
        data = INITIAL_VALUES;
      }
      updateGridField(dispatch, data);
    });
  };
};

export const clearBidPriceError = () => {
  return {
    type: types.BID_PRICE_ERROR,
  };
};

export const resetBidPriceData = originalBidPriceData => {
  return dispatch =>
    dispatch({
      type: types.RESET_BID_PRICE_DATA,
      payload: originalBidPriceData,
    });
};

export const resetPayload = () => {
  return dispatch =>
    dispatch({
      type: types.RESET_DELETE_IDS,
    });
};

export const clearBidPriceData = () => {
  return dispatch => {
    dispatch({
      type: types.CLEAR_BID_PRICE_DATA,
    });
  };
};

export const addNewPurchaseUnit = purchaseUnit => {
  return dispatch =>
    dispatch({
      type: types.BID_PRICE_ADD_PURCHASE_UNIT,
      payload: purchaseUnit,
    });
};

export const addNewSecUnit = secUnit => {
  return dispatch =>
    dispatch({
      type: types.BID_PRICE_ADD_SEC_UNIT,
      payload: secUnit,
    });
};



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/updateBidPriceDetails/actions.js